module.exports = __webpack_public_path__ + "img/phantom-icon.e100655a.png";